export default "__VITE_ASSET__D__5Z5hX__"